import React, { Component } from 'react'
import Page from './Page'
import { Link } from 'react-router-dom'
import styled from 'styled-components';
import * as variables from '../../styles/variables'
import checkRequiredFields, { validString, validRadio} from '../../helpers/check-required-fields';
import iconClock from '../../images/icon-clock.svg';
import iconExternal from '../../images/icon-external.svg';
import { Checkmark } from '../generic'

import Component1 from '../shapes/1';
import Component2 from '../shapes/2';
import Component3 from '../shapes/3';
import Component4 from '../shapes/4';
import Component5 from '../shapes/5';
import Component6 from '../shapes/6';
import Component7 from '../shapes/7';
import Component8 from '../shapes/8';
import Component9 from '../shapes/9';
import Component10 from '../shapes/10';

const Wrapper = styled.div`
  @media (max-width: ${variables.breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`

const Due = styled.div`
  display: flex;
  color: ${variables.colours.primary};
  margin-top: 5px;
  img {
    margin-right: 4px;
  }
`

const Anchor = styled.a`
  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`

const StepLink = styled(Link)`
  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`

export const STEPS = {
	"profile": {
		title: "Your Account",
		requiredFields: ['firstname', 'lastname', 'email'],
    component: Component1,
    paddingLeft: 62.46,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
	},
  "save-the-date": {
    title: "Save the Date",
    requiredFields: ['step_save_the_date_visited'],
    component: Component2,
    paddingLeft: 72.5,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
  },
	"swag": {
		title: "Host Perks",
		requiredFields: [
      'swag',
      (event) => {
        if (
          validRadio(event.swag, true) &&
          !(validString(event.swag_address_1) && validString(event.swag_city) && validString(event.swag_postal))) {
          return false
        }
        else {
          return true
        }
      }
    ],
    component: Component3,
    paddingLeft: 37,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
    unfilled: (props) => {
      return (
        <React.Fragment>
          <Due>
            <img src={iconClock} width="17" height="20"/>Do by Sept 30
          </Due>
        </React.Fragment>
      )
    },
	},
  "event": {
  	title: "Event Invitation",
		requiredFields: ["published"],
    component: Component4,
    paddingLeft: 76.5,
    filled: (props) => {
      const eventURL = `${process.env.REACT_APP_BASE_URL}/event/${props.userEvent.token}`
      return (
        <div>
          <div style={{marginBottom: '5px'}}><Checkmark /> Done</div>
          <Due>
            <img src={iconExternal} width="17" height="20"/><a href={eventURL} target="_blank">View Invitation</a>
          </Due>
        </div>
      )
    },
    // unfilled: (props) => {
    //   return (
    //     <React.Fragment>
    //       <Due>
    //         <img src={iconClock} width="17" height="20"/>Do by September
    //       </Due>
    //     </React.Fragment>
    //   )
    // },
  },
  "how-to-invite": {
  	title: "How to Invite People",
  	requiredFields: ['step_invite_visited'],
    component: Component5,
    paddingLeft: 76,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
    // unfilled: (props) => {
    //   return (
    //     <React.Fragment>
    //       <Due>
    //         <img src={iconClock} width="17" height="20"/>Do 1 month<br/> before event
    //       </Due>
    //     </React.Fragment>
    //   )
    // },
  },
  "guests": {
  	title: "Guest List",
  	requiredFields: [
      (event) => event.guests && event.guests.length > 0
      ], // TODO check for guests?
    component: Component6,
    paddingLeft: 70.5,
    filled: (props) => {
      return (
        <React.Fragment>
          <Due>
            <span>{props.guests.length} {props.guests.length === 1 ? 'response' : 'responses'}</span>
          </Due>
        </React.Fragment>
      )
    },
  },
  "reminder": {
  	title: "Send a Reminder",
  	requiredFields: ['step_reminder_visited'],
    component: Component7,
    paddingLeft: 77,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
    unfilled: (props) => {
      return (
        <React.Fragment>
          <Due>
            <img src={iconClock} width="17" height="20"/>Do 1 week<br/> before event
          </Due>
        </React.Fragment>
      )
    },
  },
  "thank-you": {
    title: "Send a Thank You",
    requiredFields: ['step_thank_you_visited'],
    component: Component8,
    paddingLeft: 70,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
  },
  "share": {
  	title: "Share Your Experience",
  	requiredFields: ['step_share_visited'],
    component: Component9,
    paddingLeft: 54,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
    // unfilled: (props) => {
    //   const eventDate = new Date("September 25, 2019")
    //   const now = new Date()
    //   return (
    //     <React.Fragment>
    //       {now < eventDate && <Due><img src={iconClock} width="17" height="20"/>Available on Sept 25</Due>}
    //     </React.Fragment>
    //   )
    // },
  },
  "survey": {
    title: "Take the Survey",
    requiredFields: ['step_survey_visited'],
    component: Component10,
    paddingLeft: 72,
    filled: (props) => {
      return (<div><Checkmark /> Done</div>)
    },
    // unfilled: (props) => {
    //   const eventDate = new Date("October 3, 2020")
    //   const now = new Date()
    //   return (
    //     <React.Fragment>
    //       {now < eventDate && <Due><img src={iconClock} width="17" height="20"/>Available soon</Due>}
    //     </React.Fragment>
    //   )
    // },
  },
}

class Step extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filled: checkRequiredFields(STEPS[this.props.slug].requiredFields, this.props.userEvent, this.props.currentUser, {guests: this.props.guests}),
		}
	}

	componentWillReceiveProps(nextProps) {
    this.setState({
      filled: checkRequiredFields(STEPS[nextProps.slug].requiredFields, nextProps.userEvent, nextProps.currentUser, {guests: nextProps.guests}),
    })
	}

  render() {
  	const { slug } = this.props
  	const { title } = STEPS[slug]
    const Shape = STEPS[slug].component

  	let url
  	if (slug === "event") {
  		url = "/host/hub/event"
  	} else if (slug === "guests") {
      url = "/host/hub/guests"
    } else {
  		url = `/host/hub/forms/${slug}`
  	}

    let passedDate
    if (this.props.userEvent && typeof this.props.userEvent.invitation_date === 'string') {
      let dateComponents = this.props.userEvent.invitation_date.split("-")
      let eventDate = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      const now = new Date()
      passedDate = now < eventDate
    }
    else {
      passedDate = false
    }

    return (
      <>
      	<Wrapper>
          {slug === 'share' && (
            <Anchor onClick={this.props.onShare} className={passedDate ? "disabled" : ""}>
              <Shape disabled={false} filled={this.state.filled} />
            </Anchor>
          )}
          {slug === 'survey' && (
            <Anchor onClick={this.props.onSurvey} className={passedDate ? "disabled" : ""}>
              <Shape disabled={false} filled={this.state.filled} />
            </Anchor>  // selected date is in the past
          )}
          {slug === 'thank-you' && (
            <StepLink to={url} className={passedDate ? "disabled" : ""}>
              <Shape disabled={false} filled={this.state.filled} />
            </StepLink>
          )}
          {['share', 'survey', 'thank-you'].indexOf(slug) === -1 && (
          	<StepLink to={url}>
              <Shape disabled={false} filled={this.state.filled} />
            </StepLink>
          )}
          <div style={{paddingLeft: STEPS[slug].paddingLeft, marginTop: "-8px" }}>
            {this.state.filled && STEPS[slug].filled && STEPS[slug].filled(this.props)}
            {!this.state.filled && STEPS[slug].unfilled && STEPS[slug].unfilled(this.props)}
          </div>
      	</Wrapper>
        {slug === 'share' && this.state.filled && (
          <Wrapper><h1 style={{ marginTop: '60px', maxWidth: '320px', marginLeft: '20px' }}>Thank you for your support this year!</h1></Wrapper>
        )}
      </>
    )
  }
}

export default Step
